export const GTM_LIST_LABEL = 'standard';
export const GTM_WISHLIST_PAGE_TYPE = 'wishlist';
export const PRODUCTS_PER_PAGE = 8;
